import { Component, OnInit, ViewChild} from '@angular/core';
import { HelperService, AppSettings, AuthenticationService } from '../../../services/_services';
import { Router, Route, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject  } from 'rxjs';
import { Base64Pipe } from '../../../services/pipes/base64/base64.pipe';
import Swal from 'sweetalert2';
declare var document,$,modal;

@Component({
  selector: 'app-modify-order',
  templateUrl: './modify-order.component.html',
  styleUrls: ['./modify-order.component.css']
})
export class ModifyOrderComponent implements OnInit {
  @ViewChild('myPond') myPond: any;

  public regionArr              : any = [
                                          { id: 1, name: 'IT' },
                                          { id: 2, name: 'SEO' },
                                          { id: 3, name: 'SM' },
                                          { id: 4, name: 'HR' },
                                      ];
  public regionNo               : any;

  public currentUrl             : any;
  public routerSubscription     : any;
  public orderId                : any;
  public orderDetail            : any;
  public userDetail             : any;
  public noOfPages              : any = AppSettings.noOfPages;
  public subjectArr             : any = ["Biology and Life Sciences","Business and Management","Chemistry","Culture","Economics","Education","English","Environmental Science","Finance, Accounting and Banking","Geography","Project Management","Operational Plan","Critical review","Critical Appraisal","Capstone","Reflective Thinking","Healthcare and Nursing","History and Anthropology","HRM","International Relations","IT","Law and International Law","Linguistics","Literature",
                                          "Marketing and PR","Maths","Philosophy","Physics","Political Science","Psychology","Sociology","Statistics","Other"]
  public citationArr            : any = ["AMA","APA","AMS","Chicago","MLA","Turbian","Other"]
  public orderForm              : FormGroup;

  public orderDate              : any;

  public base64Pipe         : any = new Base64Pipe;

  public websites               : any = [{url:"www.myperfectwords.com", abbr:'MPW'},{url:"www.sharkpapers.com", abbr:'SP'},{url:"www.freeessaywriter.net", abbr:'FEW'},{url:"www.myperfectpaper.net", abbr:'MPP'},
                                        {url:"www.championpapers.com", abbr:'CP'},{url:"www.5staressays.com", abbr:'5SE'},{url:"www.essaywritingservice.college", abbr:'EWS'},{url:"www.writemyessay.help", abbr:'WME'},
                                        {url:"www.essaywriter.college", abbr:'EWC'},{url:"www.collegeessay.org", abbr:'CE'},{url:"www.essaywritingforme.com", abbr:'EWFM'},{url:"www.topgradewriting.com", abbr:'TGW'}];


  public propGallery      : any = [];
  public orderFiles1      : any = [];
  public fileUploadLoader : any = false;
  public submitted        : any = false;
  public loader           : any = false;
  public resetLoader      : any = false;
  public orderDetail_Copy : any = [];
  public userDetail_Copy  : any = [];
  public orderDate_Copy   : any;
  public DOC_URL                  : any = AppSettings.DOC_URL
  public docs_revised_orders_path : any = AppSettings.docs_revised_orders_path
  public documentTypes            : any = AppSettings.documentType
  public fileDeleted_loader : any;
  public confirmemailV      = false;
  public loaderDelete       : any;


    pondOptions1 = {
        allowMultiple: true,
        labelIdle: `
        <p class='pond-badge'>
            <span class='badgeSub'>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0743 4.5253C9.61995 4.4427 9.15149 4.44144 8.69659 4.52161C8.24169 4.60177 7.81216 4.76126 7.43221 4.98827C6.66445 5.44699 6.15428 6.1461 5.98188 6.91416C5.90502 7.25657 5.60101 7.4999 5.25009 7.4999C4.50272 7.4999 3.7923 7.7842 3.27354 8.2804C2.75592 8.77551 2.47168 9.43974 2.47168 10.1249C2.47168 10.8101 2.75592 11.4743 3.27354 11.9694C3.7923 12.4656 4.50272 12.7499 5.25009 12.7499C5.6643 12.7499 6.00009 13.0857 6.00009 13.4999C6.00009 13.9141 5.6643 14.2499 5.25009 14.2499C4.12588 14.2499 3.04137 13.823 2.23671 13.0534C1.43092 12.2826 0.97168 11.2299 0.97168 10.1249C0.97168 9.01985 1.43092 7.96719 2.23671 7.19643C2.90455 6.55764 3.76516 6.15498 4.68125 6.03651C5.0398 5.07179 5.74128 4.25123 6.66285 3.7006C7.20375 3.37743 7.80646 3.15536 8.43626 3.04437C9.06604 2.93338 9.71349 2.93512 10.3426 3.0495C10.9717 3.16388 11.573 3.38923 12.1119 3.71539C12.6509 4.0416 13.1185 4.46336 13.4847 4.95989C13.8512 5.45666 14.1085 6.01803 14.2379 6.61266C14.3016 6.90587 14.3335 7.20342 14.3334 7.50093C15.1983 7.52227 16.0233 7.87515 16.6366 8.48842C17.2695 9.12135 17.6251 9.9798 17.6251 10.8749C17.6251 11.77 17.2695 12.6285 16.6366 13.2614C16.0036 13.8943 15.1452 14.2499 14.2501 14.2499H13.5001C13.0859 14.2499 12.7501 13.9141 12.7501 13.4999C12.7501 13.0857 13.0859 12.7499 13.5001 12.7499H14.2501C14.7474 12.7499 15.2243 12.5524 15.5759 12.2007C15.9275 11.8491 16.1251 11.3722 16.1251 10.8749C16.1251 10.3776 15.9275 9.90071 15.5759 9.54908C15.2243 9.19745 14.7474 8.9999 14.2501 8.9999H13.5001C13.2723 8.9999 13.0569 8.89639 12.9146 8.71857C12.7722 8.54075 12.7184 8.30788 12.7683 8.08564C12.8538 7.70462 12.8551 7.31293 12.7721 6.93154C12.6891 6.54995 12.5225 6.1823 12.2776 5.85031C12.0325 5.51807 11.7134 5.22755 11.3352 4.99864C10.9569 4.76967 10.5286 4.6079 10.0743 4.5253Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.46975 8.46956C8.76265 8.17666 9.23752 8.17666 9.53041 8.46956L11.7804 10.7196C12.0733 11.0124 12.0733 11.4873 11.7804 11.7802C11.4875 12.0731 11.0126 12.0731 10.7198 11.7802L9.00008 10.0605L7.28041 11.7802C6.98752 12.0731 6.51265 12.0731 6.21975 11.7802C5.92686 11.4873 5.92686 11.0124 6.21975 10.7196L8.46975 8.46956Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00008 8.24989C9.4143 8.24989 9.75008 8.58567 9.75008 8.99989V15.7499C9.75008 16.1641 9.4143 16.4999 9.00008 16.4999C8.58587 16.4999 8.25008 16.1641 8.25008 15.7499V8.99989C8.25008 8.58567 8.58587 8.24989 9.00008 8.24989Z" fill="white"/>
            </svg>
            Upload attachments</span><span> or drag them in </span>
            </p>`,
        allowImagePreview: true,
        maxFileSize: '5MB',
        imagePreviewMaxFileSize: '5MB',
      // stylePanelLayout: 'compact circle',
      server: {
          url: AppSettings.API_ENDPOINT,
          timeout: 200000,
          process: {
              url: './admin/upload-temp-files',
              method: 'POST',
              withCredentials: false,
              timeout: 30000,
              onload: (response) => {
                let parsedData = JSON.parse(response);
                // console.log("response.data******", response.data);
                let decrptedImg = this.helperService.decrypted(parsedData.data);
                let image = JSON.parse(decrptedImg);
                // console.log("image",image);

                // let name  = image.name;
                let id  = image.id;

                  // Add image to pro image array
                  this.propGallery.push(id);
                  this.fileUploadLoader = false;
                  return id;
              },
              onerror: (response) => {
                  return response.key;
              },
              ondata: (formData) => {
                  this.fileUploadLoader = true;
                  return formData;
              }
          },
          revert: (uniqueFileId, load, error) => {
              this.propGallery.splice(this.propGallery.indexOf(uniqueFileId), 1);
              // Clear Image
              load();
          },
          restore : null,
          load    : null,
          fetch   : null
      }
    }
  pondFiles = []
  constructor(
    private helperService           : HelperService,
    private activatedRoute          : ActivatedRoute,
    private formBuilder             : FormBuilder,
    private router                  : Router
  ) {
    this.routerSubscription = this.activatedRoute.params.subscribe(routeParams => {
      this.orderId = this.base64Pipe.decode(routeParams.slug);
      this.getOrderDetails();
  	});

    this.currentUrl = this.router.url;
    this.orderForm = this.formBuilder.group({
      website: [null],
      work_type: [null],
      deadline: [null],
      pages: [null],
      amount: [null],
      name : [null],
      email : [null,[Validators.email]],

      // confirm_email : [null,[ .required, .email]],
      phone : [null],
      subject : [null],
      citation : [null],
      sources : [null],
      title : [null],
      description : [null]
    });

  }

  ngOnInit(): void {


  }

  getOrderDetails(){
    let url = AppSettings.API_ENDPOINT + "admin/order";
    let data = { oid : this.orderId};
    this.helperService.httpPostRequestsDecryp(url, data).then(resp => {
      if(typeof resp != "undefined") {
        this.orderDetail = JSON.parse(resp).order;

        this.userDetail = JSON.parse(resp).user;

        this.orderDetail.delivery_date = this.orderDetail.delivery_date.replace(/\s/g, "T");

        if(Date.parse(this.orderDetail.delivery_date) == NaN) {
            // this.orderDetail.other_due_date = '';
            this.orderDetail.delivery_date  = '';
            this.orderDate                  = '';
        } else {
            // this.orderDate = new Date(this.orderDetail.other_due_date);
            this.orderDate = new Date(this.orderDetail.delivery_date);

            if(this.orderDate == 'Invalid Date'){
                this.orderDate = '';
            }
        }



        if(!this.orderDetail.work_type)
        this.orderDetail.work_type = null;


        // Set Copies
        this.orderDetail_Copy = $.extend(true, {}, this.orderDetail);
        this.userDetail_Copy = $.extend(true, {}, this.userDetail);

        this.orderFiles1 = this.orderDetail.attach_1.split("~")
      }
    });
  }


  openCheckModal(index) {
    this.loaderDelete = index;
    $("#paid_modal_" + index).modal("show");
    let self = this;
    $(".modal-backdrop").click(function() {
      self.loaderDelete = null;
      $("#paid_modal_" + index).modal("hide");
    });
  }
  closeCheckModal(index) {
    this.loaderDelete = null;
    $("#paid_modal_" + index).modal("hide");
  }

  deleteAttachments(item,index){
    let url = AppSettings.API_ENDPOINT + "admin/delete-order-file";
    let data = { oid : this.orderDetail.id,file_name: item};
    this.helperService.httpPostRequests(url, data).then(resp => {
      if(typeof resp != "undefined") {
        if(resp.status != "ERROR" ){
          this.fileDeleted_loader = true;
          this.orderFiles1.splice(this.orderFiles1.indexOf(item), 1);
          let self = this;
          setTimeout(() => {
            self.fileDeleted_loader = false;
          }, 1000);
        }
        if(resp.status == "ERROR" ){
            Swal.fire('', resp.message , "error");
        }
      }
    });
  }

  get f() { return this.orderForm.controls; }

  submitDetails(){
    this.submitted = true;

    if (this.orderForm.invalid) {
      return;
    }
    if ((this.userDetail.email != this.userDetail.confirm_email && this.userDetail.email != this.userDetail_Copy.email)) {
      this.confirmemailV      = true;
      return;
    }

      this.confirmemailV      = false;
      let url = AppSettings.API_ENDPOINT + "admin/update-order";
      this.loader = true;

      let data = this.orderDetail;
          data.oid                   = this.orderDetail.id;
          data.first_name            = this.userDetail.first_name;
          data.phone                 = this.userDetail.phone;
          data.email                 = this.userDetail.email;
          data.attach_doc            = this.propGallery;
          // data.delivery_date         = this.getCurrentDateTimeString(this.convertDateTimeToString(this.orderDate));
          data.other_due_date        = this.getCurrentDateTimeString(this.convertDateTimeToString(this.orderDate));
          data.work_type             = this.orderDetail.work_type;

          this.helperService.httpPostRequests(url, data).then(resp => {
            if(typeof resp != "undefined") {

              if(resp.status != "ERROR" ){
                Swal.fire('', resp.message , "success");

                // Get new data
                this.router.navigateByUrl('/search-orders', {skipLocationChange: true}).then(()=>
                  this.router.navigate([this.currentUrl])
                );
              }
              if(resp.status == "ERROR" ){
                Swal.fire('', resp.message , "error");
              }
              this.loader = false;
            }
          });
  }

  resetForm() {
    this.resetLoader = true;
    this.orderDetail = $.extend(true, {}, this.orderDetail_Copy);
    this.userDetail = $.extend(true, {}, this.userDetail_Copy);
    // this.orderDate = $.extend(true, {}, this.orderDate_Copy);

    this.orderDate = new Date(this.orderDetail_Copy.other_due_date);

    this.propGallery = [];
    this.myPond.removeFiles();

    this.submitted    = false;
    this.confirmemailV  = false;

    let self = this;
    setTimeout(() => {
      self.resetLoader = false;
    }, 500);
  }

  transformDate(value: any) {
    if(value) {
      let d = value;
      let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      return monthNames[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear() + ' ' + this.formatAMPM(value);
    }

    return '';
  }

  convertDateTimeToString(timestamp, start = true){
    var x = new Date(timestamp);
    var dd = x.getDate() > 9 ? x.getDate() : '0' + x.getDate();
    var mm = x.getMonth() + 1 > 9 ? x.getMonth() + 1 : '0' + (x.getMonth() + 1);
    var yy = x.getFullYear();
    if(start)
      return yy + "-" + mm + "-" + dd + " " + this.formatAMPM(timestamp);
    else
      return yy + "-" + mm + "-" + dd + " " + this.formatAMPM(timestamp);
  }

  formatAMPM(date) {
    date = new Date(date);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  caonvertDateToString(timestamp){
    var x = new Date(timestamp);
    var dd = x.getDate();
    var mm = x.getMonth()+1;
    var yy = x.getFullYear();
    return yy +"-" + mm+"-" + dd;
  }

  getCurrentDateTimeString(dateString) {
    var date = new Date(dateString);

    var yr   = date.getFullYear();
    var mon  = date.getMonth() + 1;
    var mo   = mon < 10 ? '0' + mon : mon;
    var dayI = date.getDate();
    var day  = dayI < 10 ? '0' + dayI : dayI;

    var hours = date.getHours();
    var hr = hours < 10 ? '0' + hours : hours;

    var minutes = date.getMinutes();
    var min = (minutes < 10) ? '0' + minutes : minutes;

    var seconds = date.getSeconds();
    var sec = (seconds < 10) ? '0' + seconds : seconds;

    var newDateString = yr + '-' + mo  + '-' + day;
    var newTimeString = hr + ':' + min + ':' + sec;

    // 2021-07-01T19:00:00.000Z
    // 2021-07-01T00:00:00
    // 2021-07-01T00:00:00.000Z
    return newDateString + 'T' + newTimeString;
    // return newDateString + 'T' + newTimeString + '.000Z';
  }

  pondHandleInit() {
    console.log('FilePond has initialised', this.myPond);
  }

  pondHandleAddFile(event: any) {
    console.log("this.myPond", this.myPond);

    // console.log('A file was added', event);
  }

  pondHandleActivateFile(event: any) {
    console.log('A file was activated', event)
  }


}
